const gpt_engine = async (env, scope, isGlobal, search_level, messages, onStream, onReferences, abortSignal) => {

    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (!userDetails || !userDetails.email || !userDetails.session_id) {
        console.error('User details are missing or incomplete in localStorage.');
        onStream('Session Expired or User Unauthorized. Please log in again: relogin link');
        return;
    }

    const endpoints = {
        'DEV': "https://netaichat-dev-engine.netapp.com/gpt_engine",
        'STG': "https://netaichat-stg-engine.netapp.com/gpt_engine",
        'PRD': "https://netaichat-engine.netapp.com/gpt_engine"
    };

    console.log(`Environment set to ${env in endpoints ? env : 'Others'}`);
    const gpt_endpoint = endpoints[env] || endpoints['DEV'];
    const isGlobalBool = isGlobal;
    messages = messages.slice(1, messages.length); // Remove the first message
    console.log('Inside gpt_engine function');
    console.log('scope:', scope);

    if (search_level === "" || isNaN(parseInt(search_level))) {
        search_level = '5';
    }

    // Get current site URL
    const currentSiteUrl = window.location.href;
    console.log('Current site URL:', currentSiteUrl);

    // Define scope configurations using a mapping object
    const scopeConfigs = {
        'gethelp': {
            master_scope_enable: true,
            gethelp: true
        },
        'sechelp': {
            master_scope_enable: true,
            sechelp: true
        },
        'cloudonedoc': {
            master_scope_enable: true,
            cloudonedoc: true
        },
        'competebot': {
            master_scope_enable: true,
            competebot: true
        },
        'maiawiki': {
            master_scope_enable: true,
            maiawiki: true
        },
        'noscope': {
            master_scope_enable: false
        },
        'sharepointlite': {
            master_scope_enable: true,
            netaimini_share: true
        },
        'sharepointliteall': {
            master_scope_enable: true,
            netaimini_share: true
        }
    };

    // Get scope configuration or use default (all false)
    const scopes = scopeConfigs[scope] || {
        master_scope_enable: false,
        gethelp: false,
        sechelp: false,
        cloudonedoc: false,
        competebot: false,
        maiawiki: false,
        netaimini_share: false
    };

    // Prepare headers according to Python endpoint expectations
    const headers = {
        'Content-Type': 'application/json',
        'email': userDetails.email,
        'sso': userDetails.sso_id || '',
        'session': userDetails.session_id,
        'model': "gpt-5-chat",
        'chat-id': "maia-mini-1234",
    };

    // Check if current site URL contains "netapp.com" and add site-id header
    if (scope !== "sharepointliteall" && !isGlobalBool && currentSiteUrl.includes("netapp.sharepoint.com")) {
        try {
            const url = new URL(currentSiteUrl);
            const pathParts = url.pathname.split('/').filter(part => part); // Remove empty parts
            const protocolAndDomain = `${url.protocol}//${url.hostname}`;

            // Check if this is a sites URL structure
            const sitesIndex = pathParts.indexOf('sites');

            if (sitesIndex !== -1 && sitesIndex + 1 < pathParts.length) {
                const siteName = pathParts[sitesIndex + 1];
                const siteUrl = `${protocolAndDomain}/sites/${siteName}`;
                headers['site_id'] = siteUrl;
                console.log('NetApp SharePoint site detected, added site-id header:', siteUrl);
            } else {
                // Fallback to just the domain if sites structure is not found
                headers['site_id'] = protocolAndDomain;
                console.log('NetApp SharePoint domain detected, added site-id header:', protocolAndDomain);
            }
        } catch (error) {
            console.warn('Error parsing URL for site_id:', error);
            // Fallback to original domain extraction method
            const urlParts = currentSiteUrl.split('/');
            const protocolAndDomain = urlParts.slice(0, 3).join('/');
            headers['site_id'] = protocolAndDomain;
            console.log('NetApp SharePoint domain detected (fallback), added site-id header:', protocolAndDomain);
        }
    }

    // Add scopes header as JSON string if master_scope_enable is true
    if (scopes.master_scope_enable) {
        headers['scopes'] = JSON.stringify(scopes);
    }

    // Add sso header if available
    if (userDetails.sso) {
        headers['sso'] = userDetails.sso;
    }

    if (scopes.netaimini_share) {
        headers['max_files'] = search_level;
    }

    // Prepare body according to Python endpoint expectations
    const body = {
        model: "gpt-5-chat",
        messages: messages,
        temperature: 0.5,
        stream: true
    };

    try {
        const response = await fetch(gpt_endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: abortSignal // Pass the abort signal to the fetch request
        });

        // Handle different HTTP status codes
        if (!response.ok) {
            let errorMessage = '';

            switch (response.status) {
                case 401:
                    console.log('401 Unauthorized - Session expired');
                    errorMessage = 'Session Expired or User Unauthorized try to relogin: relogin link';
                    break;

                case 403:
                    console.log('403 Forbidden - Access denied');
                    errorMessage = 'Access denied. You don\'t have permission to access this service. Please try to relogin or contact your administrator: relogin link';
                    break;

                case 404:
                    console.log('404 Not Found - Service endpoint not found');
                    errorMessage = 'Service not found. The chat service is temporarily unavailable. Please refresh the chat or try again later: refresh chat';
                    break;

                case 429:
                    console.log('429 Too Many Requests - Rate limit exceeded');
                    errorMessage = 'Too many requests. Please wait a moment and try again. You can refresh the chat to continue: refresh chat';
                    break;

                case 500:
                    console.log('500 Internal Server Error');
                    errorMessage = 'Internal server error. The service is experiencing technical difficulties. Please refresh the chat or try again later: refresh chat';
                    break;

                case 502:
                    console.log('502 Bad Gateway');
                    errorMessage = 'Service temporarily unavailable. Please refresh the chat or try again in a few moments: refresh chat';
                    break;

                case 503:
                    console.log('503 Service Unavailable');
                    errorMessage = 'Service is temporarily unavailable for maintenance. Please try again later or refresh the chat: refresh chat';
                    break;

                case 504:
                    console.log('504 Gateway Timeout');
                    errorMessage = 'Request timeout. The service is taking longer than expected to respond. Please refresh the chat and try again: refresh chat';
                    break;

                default:
                    console.log(`${response.status} ${response.statusText} - Unexpected error`);
                    errorMessage = `Unexpected error occurred (${response.status}). Please refresh the chat or try to relogin: refresh chat`;
                    break;
            }

            // Stream the error message
            onStream(errorMessage);
            return;
        }

        if (!response.body) {
            throw new Error('ReadableStream not supported in this browser.');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let extractedReferences = [];

        // Define these functions outside the loop to avoid ESLint no-loop-func warning
        const processReferences = (content) => {
            // Check if content contains references in the format !{urls}<url>
            if (content.startsWith('!{urls}<') && content.endsWith('>')) {
                try {
                    // Extract URL from the content format: !{urls}< and >
                    const url = content.slice(8, -1); // Remove !{urls}< and >
                    if (url && url.trim()) {
                        extractedReferences.push(url.trim());
                        console.log('Extracted reference:', url.trim());
                        // Send references to callback only if we have URLs and callback exists
                        if (onReferences && typeof onReferences === 'function' && extractedReferences.length > 0) {
                            onReferences([...extractedReferences]);
                        }
                    }
                } catch (parseError) {
                    console.error('Error parsing reference URL:', parseError);
                }
            } else if (content.startsWith('!{urls}')) {
                // Fallback: try to parse as JSON array format (legacy support)
                try {
                    const urlsContent = content.replace('!{urls}', '').trim();
                    const urls = JSON.parse(urlsContent);
                    if (Array.isArray(urls) && urls.length > 0) {
                        extractedReferences = [...extractedReferences, ...urls];
                        console.log('Extracted references (JSON array):', urls);
                        // Send references to callback only if we have URLs and callback exists
                        if (onReferences && typeof onReferences === 'function') {
                            onReferences(extractedReferences);
                        }
                    }
                } catch (parseError) {
                    console.error('Error parsing references as JSON array:', parseError);
                }
            } else {
                // Filter out content that starts with !{urls} but allow markdown tables and other content
                onStream(content);
            }
        };

        while (true) {
            // Check if the request was aborted before reading
            if (abortSignal && abortSignal.aborted) {
                reader.cancel();
                throw new DOMException('Request was aborted', 'AbortError');
            }

            const { done, value } = await reader.read();
            if (done) {
                break;
            }

            // Check again after reading in case abort happened during read
            if (abortSignal && abortSignal.aborted) {
                reader.cancel();
                throw new DOMException('Request was aborted', 'AbortError');
            }

            const chunkStr = decoder.decode(value, { stream: true });

            buffer += chunkStr;

            const segments = buffer.split('data: ');
            buffer = segments.pop(); // Keep the last segment in the buffer

            segments.forEach(segment => {
                segment = segment.trim();
                if (segment === '[DONE]') {
                    // Handle the [DONE] token
                    console.log('Stream finished');
                }
                else if (segment) {
                    try {
                        const data = JSON.parse(segment);
                        if (data.choices && data.choices[0] && data.choices[0].delta && data.choices[0].delta.content) {
                            const content = data.choices[0].delta.content;
                            processReferences(content);
                        }
                    } catch (err) {
                        console.error('Error parsing JSON:', err);
                        console.error('Problematic JSON string:', segment);
                        // Continue processing instead of breaking on JSON parse errors
                    }
                }
            });
        }

        // Handle any remaining buffer content
        if (buffer && buffer.trim() !== '[DONE]') {
            try {
                const data = JSON.parse(buffer);
                if (data.choices && data.choices[0] && data.choices[0].delta && data.choices[0].delta.content) {
                    const content = data.choices[0].delta.content;

                    // Check for references in remaining buffer
                    if (content.startsWith('!{urls}')) {
                        try {
                            const urlsContent = content.replace('!{urls}', '').trim();
                            const urls = JSON.parse(urlsContent);
                            if (Array.isArray(urls)) {
                                extractedReferences = [...extractedReferences, ...urls];
                                console.log('Extracted references from buffer:', urls);
                                if (onReferences && typeof onReferences === 'function') {
                                    onReferences(extractedReferences);
                                }
                            }
                        } catch (parseError) {
                            console.error('Error parsing references from buffer:', parseError);
                        }
                    } else {
                        // Apply the same filtering logic for remaining buffer content
                        onStream(content);
                    }
                }
            } catch (err) {
                console.error('Error parsing remaining JSON:', err);
                console.error('Remaining buffer:', buffer);
                // Continue processing instead of breaking on JSON parse errors
            }
        }

        // Final callback with all collected references
        if (extractedReferences.length > 0 && onReferences && typeof onReferences === 'function') {
            onReferences(extractedReferences);
        }

    } catch (error) {
        console.error('Error querying the endpoint:', error);

        // Handle network errors and other exceptions
        let networkErrorMessage = '';
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
            networkErrorMessage = 'Network connection error. Please check your internet connection and refresh the chat: refresh chat';
        } else if (error.name === 'AbortError') {
            console.log('Request was cancelled by user');
            // Don't show an error message for user-initiated cancellation
            throw error; // Re-throw to let the calling function handle it
        } else {
            networkErrorMessage = 'An unexpected error occurred while connecting to the service. Please refresh the chat or try to relogin: refresh chat';
        }

        onStream(networkErrorMessage);
    }
};

export default gpt_engine;
